import type { ReactNode } from 'react';

/** 親の text-xl〜text-3xl に対し、年・年月日の単位を約 2 段階小さく見せる（字間もやや広げる） */
export const ANALYSIS_DATE_LABEL_SMALL =
    'inline-block align-baseline text-[0.58em] font-semibold tabular-nums leading-none tracking-[0.12em]';

/** 和文の波ダッシュを半角チルダに統一 */
function normalizeJaRangeTilde(s: string): string {
    return s.replace(/[\u301C\uFF5E]/g, '~');
}

/**
 * 分析バー用: formatDateStr 後の「2025年 4月 3日 ~ 9日」形式（数字と単位は詰め、ブロック間のみスペース）。
 */
export function renderJaBarDateLabel(text: string): ReactNode {
    const normalized = normalizeJaRangeTilde(text).replace(/\u3000/g, ' ');
    const out: ReactNode[] = [];
    let i = 0;
    let k = 0;
    const small = ANALYSIS_DATE_LABEL_SMALL;

    while (i < normalized.length) {
        const ch = normalized[i];
        if (ch === ' ') {
            out.push(<span key={k++}> </span>);
            i += 1;
            continue;
        }

        const slice = normalized.slice(i);
        let m = slice.match(/^(\d{4})年/);
        if (m) {
            out.push(
                <span key={k++} className={small}>
                    {m[1]}
                </span>,
            );
            out.push(
                <span key={k++} className={small}>
                    年
                </span>,
            );
            i += m[0].length;
            continue;
        }
        m = slice.match(/^(\d{1,2})月/);
        if (m) {
            out.push(<span key={k++}>{m[1]}</span>);
            out.push(
                <span key={k++} className={small}>
                    月
                </span>,
            );
            i += m[0].length;
            continue;
        }
        m = slice.match(/^(\d{1,2})日/);
        if (m) {
            out.push(<span key={k++}>{m[1]}</span>);
            out.push(
                <span key={k++} className={small}>
                    日
                </span>,
            );
            i += m[0].length;
            continue;
        }
        out.push(<span key={k++}>{ch}</span>);
        i += 1;
    }

    return <>{out}</>;
}

/**
 * 英語バー用: 西暦 4 桁を小さく（例: Apr 3, 2025）
 */
export function renderEnBarDateLabel(text: string): ReactNode {
    const parts = text.split(/(\d{4})/g);
    const small = ANALYSIS_DATE_LABEL_SMALL;
    return (
        <>
            {parts.map((part, idx) =>
                /^\d{4}$/.test(part) ? (
                    <span key={idx} className={small}>
                        {part}
                    </span>
                ) : (
                    <span key={idx}>{part}</span>
                ),
            )}
        </>
    );
}

/** 月グリッド（ja の「4月」など）で「月」だけ小さく */
export function JaMonthGridAbbrev({ label }: { label: string }): ReactNode {
    const m = label.match(/^(\d{1,2})(月)$/);
    if (!m) return label;
    return (
        <>
            <span>{m[1]}</span>
            <span className={ANALYSIS_DATE_LABEL_SMALL}>月</span>
        </>
    );
}
